import { StyledPartitionCard, StyledContent } from '@/components/styles';
import { Picture } from '@/components';

const ElementCard = ({ title, desc, image, video }) => {
  return (
    <StyledPartitionCard cardImage={image && Object.keys(image).length > 0 ? undefined : 'none'}>
      <StyledPartitionCard.Bg>
        {image && !video && Object.keys(image).length > 0 && <Picture {...image} />}
        {video && <video autoplay="autoplay" loop="loop" muted="muted" playsinline="playsinline" src={video}></video>}
      </StyledPartitionCard.Bg>
      <StyledPartitionCard.Content>
        <StyledPartitionCard.Title>{title}</StyledPartitionCard.Title>
        {desc && (
          <StyledContent.Description>
            <StyledContent.Html dangerouslySetInnerHTML={{ __html: desc }} />
          </StyledContent.Description>
        )}
      </StyledPartitionCard.Content>
    </StyledPartitionCard>
  );
};

export default ElementCard;
